import { render, staticRenderFns } from "./UserToCreate.vue?vue&type=template&id=ec042e9e&scoped=true&"
import script from "./UserToCreate.vue?vue&type=script&lang=js&"
export * from "./UserToCreate.vue?vue&type=script&lang=js&"
import style0 from "./UserToCreate.vue?vue&type=style&index=0&id=ec042e9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec042e9e",
  null
  
)

export default component.exports